module.exports = __webpack_public_path__ + "static/media/ic_down.f623242c.svg";